import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import { user } from "src/components/login/login";
import { myAxios } from "src/components/common/functions";
import Form from "../form";
export const items = [
    {title: "", type: "display", content: <div className = "my-2 text-secondary font-weight-bold font-italic">
    <p>
        A Good Catch is recognition of an event or circumstance that had the potential to cause property damage or injury/illness but did not occur thanks to a corrective action and/or timely intervention following the reporting.
    </p>
    <p>
        Una buena captura es el reconocimiento de un evento o circunstancia que tenía el potencial de causar daños a la propiedad o lesiones / enfermedades, pero no ocurrió gracias a una acción correctiva y / o intervención oportuna después del informe.
    </p>
    </div>}, 
    {title: "Individual Reporting", type: "text", required: true, default: user.userName}, 
    {title: "Date", type: "date", required: true}, 
    {title: "Time", type: "time"}, 
    {title: "Location", type:"text", required: true}, 
    {title: "Project Name", type: "Select", options: [], required: true}, 
    {title: "What happened? How did you react to help/assist? Who was involved? When did you notice? Where did the details of the event occur?", type: "textarea", required: true},
    {title: "Approver Notes"}
];
//--------------------------------------------------------------------------------------------
export default function GoodCatchForm({
    closeIt, 
    form, 
    picData, setPicData, 
    sketches, setSketches, 
    usersList, setUserList
}){
    const [projects, setProjects] = useState([]);
    items[5].options = projects.map(project => ({
        value: project.projectName, 
        label: project.projectName
    }));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const resProjectNames = await myAxios("common/readProjectNames.php");
            if(!isMounted) return;
            setProjects(resProjectNames.data);
            
        }
        getData();
        return () => {isMounted = false;}
    },[]);
    //--------------------------------------------------------------------------------------------
    return(
        <Form
            closeIt = {closeIt}
            form = {form}
            picData = {picData}
            setPicData = {setPicData}
            sketches = {sketches}
            setSketches = {setSketches}
            usersList = {usersList}
            setUserList = {setUserList}

            items = {items}
        />
    )    
}